import { z } from 'zod'

export const formSchema = z.object({
  date: z.string(),
  studentName: z.string(),
  oen: z.string(),
  daysAbsent: z.string(),
  totalDaysAbsent: z.string(),
  grade: z.string(),
  teacher: z.string(),
  timesLate: z.string(),
  totalTimesLate: z.string(),
  board: z.string(),
  school: z.string(),
  address1: z.string(),
  address2: z.string(),
  principal: z.string(),
  telephone: z.string(),
  boardInformation1: z.string(),
  responsibility: z.string(),
  organization: z.string(),
  independentWork: z.string(),
  collaboration: z.string(),
  initiative: z.string(),
  selfRegulation: z.string(),
  strengthsNextStepsLSWH: z.string(),
  languagePlan: z.string(),
  languageResult: z.string(),
  frenchPlan: z.string(),
  frenchResult: z.string(),
  nativeLanguage: z.string(),
  nativeLanguagePlan: z.string(),
  nativeLanguageResult: z.string(),
  mathematicsPlan: z.string(),
  mathematicsResult: z.string(),
  scienceAndTechnologyPlan: z.string(),
  scienceAndTechnologyResult: z.string(),
  socialStudiesPlan: z.string(),
  socialStudiesResult: z.string(),
  healthEducationPlan: z.string(),
  healthEducationResult: z.string(),
  physicalEducationPlan: z.string(),
  physicalEducationResult: z.string(),
  artsHeader: z.string(),
  arts1: z.string(),
  arts1Plan: z.string(),
  arts1Result: z.string(),
  arts2: z.string(),
  arts2Plan: z.string(),
  arts2Result: z.string(),
  arts3: z.string(),
  arts3Plan: z.string(),
  arts3Result: z.string(),
  arts4: z.string(),
  arts4Plan: z.string(),
  arts4Result: z.string(),
  optionalStudies: z.string(),
  optionalStudiesPlan: z.string(),
  optionalStudiesResult: z.string(),
  strengthsNextStepsSubjects: z.string(),
  boardInformation2: z.string(),
  _completedFields: z.array(z.string()).default([]),
})

export const defaultValues = {
  ...Object.fromEntries(
    Object.keys(formSchema.shape)
      .filter((k) => k !== '_completedFields')
      .map((k) => [k, ''])
  ),
  _completedFields: [],
}
